import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import DebtsComp from './DebtsComp'

function Debts() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <DebtsComp/>      
        </div>
    </div>
  )
}

export default Debts